// @ts-nocheck
import { notesStyles, OrderDetailsNotesStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsNotes";
import { orderDataLabel, orderDataValue } from "@store/Themes/common/props/checkout";

Object.assign(notesStyles, {
    titleText: orderDataLabel,
});
